import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

interface RouterHistoryType {
    previousPath: string | null;
}

const RouteHistoryContext = createContext<RouterHistoryType>({
    previousPath: null,
});

export const RouteHistoryProvider = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const [previousPath, setPreviousPath] = useState<string | null>(null);
    const currentPathRef = useRef(location.pathname);

    useEffect(() => {
        setPreviousPath(currentPathRef.current);
        currentPathRef.current = location.pathname;
    }, [location.pathname]);

    return (
        <RouteHistoryContext.Provider value={{ previousPath }}>
            {children}
        </RouteHistoryContext.Provider>
    );
};

export const useRouteHistory = (): RouterHistoryType => {
    const context = useContext(RouteHistoryContext);

    if (!context) {
        throw new Error("useRouteHistory must be used within a RouteHistoryProvider");
    }

    return context;
};
